<template>
  <div>
    <div id="maychar1" style="width: 100%; height: 300px"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {
      option: {
        backgroundColor: '#fff',
        title: {
          text: '投诉举报接受渠道对比分析',
          show: false,
        },
        tooltip: {
          trigger: 'axis',
        },

        radar: {
          indicator: [
            {
              text: '完成任务数（个）',
              max: 5000,
            },
            {
              text: '学习时长（分钟）',
              max: 5000,
            },
            {
              text: '学习课程（门）',
              max: 5000,
            },
            {
              text: '学习次数（次）',
              max: 5000,
            },
            {
              text: '学习天数（天）',
              max: 5000,
            },
          ],
          radius: 90,
          splitNumber: 9,
          name: {
            textStyle: {
              color: '#201E1F',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#B3DBF5',
              width: 2,
              type: 'dotted',
            },
          },
          splitLine: {
            lineStyle: {
              color: ['#B3DBF5', 'transparent', 'transparent', 'transparent'],
              width: 1,
            },
          },
          splitArea: {
            areaStyle: {
              color: ['#e6e6e6', '#e6e6e6'],
            },
          },
        },
        series: [
          {
            type: 'radar',
            tooltip: {
              trigger: 'item',
            },
            symbol: 'circle',
            symbolSize: 5,
            radius: '',
            itemStyle: {
              normal: {
                areaStyle: { type: 'default' },
                color: '#5DB461',
                borderColor: '#5ac3bd',
                shadowColor: 'rgba(0,0,0,0.5)',
              },
            },
            data: [
              {
                value: [3000, 3000, 3000, 3000, 3000],
                label: {
                  show: true,
                  color: '#000',
                  formatter: function (params) {
                    return params.value;
                  },
                },
                name: '投诉举报接受渠道',
              },
            ],
          },
        ],
      },
    };
  },

  created() {},
  mounted() {
    this.getCharts();
  },
  methods: {
    getCharts() {
      console.log(echarts);
      const chartBox = echarts.init(document.getElementById('maychar1'));
      let option = this.option;
      chartBox.setOption(option);
      // 根据页面大小自动响应图表大小
      window.addEventListener('resize', function () {
        chartBox.resize();
      });
    },
  },
};
</script>

<style scoped></style>
